import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/main.css'
import Root from './Root'

import 'react-s-alert/dist/s-alert-default.css'

export default Root



// WEBPACK FOOTER //
// ./index.js